var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollections(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8334 27.3333H3.16675C1.78604 27.3333 0.666748 26.214 0.666748 24.8333V11.5C0.666748 10.1193 1.78604 9 3.16675 9H24.8334C26.2141 9 27.3334 10.1193 27.3334 11.5V24.8333C27.3334 26.214 26.2141 27.3333 24.8334 27.3333ZM3.16675 9.83333C2.24627 9.83333 1.50008 10.5795 1.50008 11.5V24.8333C1.50008 25.7538 2.24627 26.5 3.16675 26.5H24.8334C25.7539 26.5 26.5001 25.7538 26.5001 24.8333V11.5C26.5001 10.5795 25.7539 9.83333 24.8334 9.83333H3.16675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6668 5.66675H2.3335V4.83341H25.6668V5.66675ZM24.0002 0.666748H4.00016V1.50008H24.0002V0.666748Z",
    fill: "url(#paint0_linear_1256_9133)",
    fillOpacity: 0.93
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1256_9133",
    x1: 2.3335,
    y1: 3.16675,
    x2: 25.6668,
    y2: 3.16675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0079B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#009FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollections);
export default __webpack_public_path__ + "static/media/collections.fe3a083682fda61c98db19adc33c6ed7.svg";
export { ForwardRef as ReactComponent };